import { render, staticRenderFns } from "./HelloWorld5.vue?vue&type=template&id=de4365ec&scoped=true&"
import script from "./HelloWorld5.vue?vue&type=script&lang=js&"
export * from "./HelloWorld5.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorld5.vue?vue&type=style&index=0&id=de4365ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4365ec",
  null
  
)

export default component.exports